import VueRouter, { Location } from 'vue-router' // eslint-disable-line no-unused-vars

export default function goBackWithFallback (router: VueRouter, from: boolean, fallbackLocation: Location, usePush: boolean = false, useLocation: boolean = false) {
  const { currentRoute } = router
  if (from && (!currentRoute.params || !currentRoute.params.fallbacked) && !useLocation) {
    router.back()
  } else if (fallbackLocation) {
    fallbackLocation.params = fallbackLocation.params || {}
    fallbackLocation.params = { ...fallbackLocation.params, fallbacked: 'true' }
    if (usePush) {
      router.push(fallbackLocation)
    } else {
      router.replace(fallbackLocation)
    }
  }
}
